@if (control) {
  <label id="{{id}}_label"
    for='{{id}}_input'
    [ngClass]="{'visually-hidden' : !label }">
    @if (label) {
      <span>
        {{ label | translate }}
        @if (required) {
          <span>*</span>
        }
      </span>
    } @else {
      Bitte geben Sie einen Wert an
    }
  </label>
  <textarea #textarea
    id="{{id}}_input"
    class="form-control"
    [rows]="rows" [cols]="cols"
    [ngClass]="{ 'ba-error': isInvalid }"
    [name]='name'
    [attr.maxlength]="maxLength"
    [placeholder]='placeholder'
    [attr.data-has-error]="isInvalid"
    [attr.data-error-message]="control.errors?.message"
    (blur)="onBlur()"
    [(ngModel)]="value">
  </textarea>
  <p class="form-text" id="{{ id }}_Zaehler">
    {{ textarea.value.length }} von {{ maxLength }} Zeichen
  </p>
  @if (isInvalid) {
    <wba-error-message
      _id="{{id}}"
      [control]="control"/>
  }
}
